// extracted by mini-css-extract-plugin
module.exports = {"description":"G2c90nkbPF_9CkSUUdcw","tabs":"PaiJ9sFypf7fJXpItMq8"};